<template>
    <div class="content">
        <h1>{{ $t('pageTitle') }}</h1>
    </div>
</template>

<script>
import { i18nMixin } from "@/vue/mixins/i18nMixin";

export default {
    name: 'feast',
    mixins: [
        i18nMixin
    ]
}
</script>

<style scoped>

</style>

<i18n>
{
    "en": {
        "pageTitle": "A Feast For Odin helper"
    },
    "fi": {
        "pageTitle": "A Feast For Odin avustin"
    }
}
</i18n>
